export const SCRIPT = `<script>
(function(apiKey){
    (function(p,e,n,d,o){var v,w,x,y,z;o=p[d]=p[d]||{};o._q=o._q||[];
    v=['initialize','identify','updateOptions','pageLoad','track'];for(w=0,x=v.length;w<x;++w)(function(m){
        o[m]=o[m]||function(){o._q[m===v[0]?'unshift':'push']([m].concat([].slice.call(arguments,0)));};})(v[w]);
        y=e.createElement(n);y.async=!0;y.src='https://cdn.pendo.io/agent/static/'+apiKey+'/pendo.js';
        z=e.getElementsByTagName(n)[0];z.parentNode.insertBefore(y,z);})(window,document,'script','pendo');
})('0873d633-99a6-4445-6a85-d8717e1c4fe1');
</script>`;

export const isPendoEnabled = (): boolean => {
    return process.env.NEXT_PUBLIC_PENDO_ENABLED !== 'false';
};

/** Fires a Pendo track event if Pendo is available. Safe to call server-side (no-ops). */
export const trackPendoEvent = (eventName: string, properties?: Record<string, unknown>): void => {
    if (typeof window === 'undefined') return;
    // @ts-expect-error - window['pendo'] is untyped
    if (typeof window['pendo'] !== 'undefined') {
        // @ts-expect-error - window['pendo'] is untyped
        window['pendo'].track(eventName, properties);
    } else {
        console.warn('trackPendoEvent: Pendo not initialized, event not tracked', { eventName, properties });
    }
};
